import { FC, ReactNode } from "react";

import Header from "./headerNav/Header";
import SiteNavigation from "./headerNav/SiteNavigation";
import PageContentWrapper from "../../SolarGikLib/PageContentWrapper";

export interface SiteGroupNavigation {
  id: number;
  name: string;
  timeZone?: string | null;
}

interface ILayoutProps {
  siteGroup?: SiteGroupNavigation;
  children: ReactNode;
  backgroundWindowStyle?: React.CSSProperties;
  layoutStyle?: React.CSSProperties;
  scrollableLayout?: boolean;
  showShadowForScrollableLayout?: boolean;
  isAiChatEnabled: boolean;
}
const Layout: FC<ILayoutProps> = ({
  children,
  siteGroup,
  backgroundWindowStyle,
  layoutStyle,
  scrollableLayout,
  showShadowForScrollableLayout,
  isAiChatEnabled,
}) => {
  return (
    <>
      <Header isAiChatEnabled={isAiChatEnabled} siteGroup={siteGroup} />
      <SiteNavigation siteGroup={siteGroup} />
      <PageContentWrapper
        layoutStyle={layoutStyle}
        backgroundWindowStyle={backgroundWindowStyle}
        scrollableLayout={scrollableLayout}
        showShadowForScrollableLayout={showShadowForScrollableLayout}
      >
        {children}
      </PageContentWrapper>
    </>
  );
};
export default Layout;
